import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Service Area', path: '/service-area' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
    { name: 'Careers', path: '/careers' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Blog', path: '/blog' },
    { name: 'Refer a Friend', path: '/referral' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-black border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_84a62b01-a803-4be5-b96e-8c3d213a1737/artifacts/1rrc08ib_ChatGPT%20Image%20Sep%2017%2C%202025%2C%2009_27_05%20AM%20%281%29.png" 
              alt="Taylormade Cleaning" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-white font-medium transition-colors hover:text-red-600 ${
                  isActive(link.path) ? 'text-red-600' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/booking">
              <Button className="bg-red-600 hover:bg-red-700 text-white">
                Book Now
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-red-600 transition-colors"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-black border-t border-gray-800">
          <div className="px-4 pt-2 pb-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-white font-medium hover:bg-gray-900 transition-colors ${
                  isActive(link.path) ? 'bg-gray-900 text-red-600' : ''
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/booking" onClick={() => setIsOpen(false)}>
              <Button className="w-full bg-red-600 hover:bg-red-700 text-white mt-2">
                Book Now
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
